import React, { useState, useRef, useEffect } from 'react';
import {
  stage as stageEnum,
  stockOnHandImg,
  getPublicFolderPath,
  getStagePosition,
  stageInTimeline,
} from '../../../../utils';
import { ILine } from '../../../../global';
import { useLinesContext } from '../../../../contexts/Lines';
import makeStyles from '@material-ui/core/styles/makeStyles';
import StockOnHandMenu from '../Stages/StockOnHandMenu';

const useStyles = makeStyles(() => ({
  stockOnHand: {
    position: 'absolute',
    cursor: 'default',
    zIndex: 200,
    transform: 'translateX(-50%)',
  },
}));

function getStage(line: ILine, stageName: string) {
  const stage = line.stages.find((stage) => stage.name === stageName);
  return stage;
}

export default function StockOnHand({
  line,
  handleStageUpdate,
  addOrDeleteError,
  timelineInfo,
  setAutoSave = (arg) => {},
  open,
  setOpen,
  className = '',
}) {
  const classes = useStyles();
  const ref = useRef();
  const stockOnHand = getStage(line, stageEnum.sellingStart.value);
  let stockOnHandPosition = getStagePosition(line, stockOnHand);
  const [openedFirstTime, setOpenedFirstTime] = useState(false);
  const { lineOnEditMode } = useLinesContext();

  const showStage = stageInTimeline(stockOnHand, timelineInfo);

  function openSellingStartMenu() {
    if ((line?.edit && lineOnEditMode) || !lineOnEditMode) {
      !open && setOpen(true);
      setAutoSave(false);
    }
  }

  useEffect(() => {
    // DISPLAY STOCK ON HAND WHENEVER USER FIRST GOES INTO EDIT MODE
    if (line.edit && !openedFirstTime) {
      setAutoSave(false);
      setTimeout(() => {
        setOpenedFirstTime(true);
        setOpen(true);
      }, 700);
    }
    if (!line.edit && openedFirstTime) {
      setOpenedFirstTime(false);
    }
    // eslint-disable-next-line
  }, [line]);

  return (
    <>
      {stockOnHand && showStage && (
        <>
          <img
            src={getPublicFolderPath(window.location.pathname) + stockOnHandImg}
            alt="Stock on Hand Icon"
            className={`${classes.stockOnHand} ${className}`}
            style={{ left: stockOnHandPosition + '%' }}
            onMouseOver={openSellingStartMenu}
            ref={ref}
          />
          <StockOnHandMenu
            line={line}
            stockOnHand={stockOnHand}
            anchorEl={ref.current}
            open={open}
            setOpen={setOpen}
            handleStageUpdate={handleStageUpdate}
            addOrDeleteError={addOrDeleteError}
            setAutoSave={setAutoSave}
            stockOnHandPosition={stockOnHandPosition}
          />
        </>
      )}
    </>
  );
}
